export default "__VITE_ASSET__g2lceAK6__"